import { ShapeType } from '@/shared/api/BaseAPI.model'

function getTableCardImageSize(shape: ShapeType) {
  switch (shape) {
    case 'square':
      return { width: 508, height: 508 }
    case 'circle':
      return { width: 523, height: 523 }
    case 'verticalRectangle':
      return { width: 472, height: 700 }
    case 'horizontalRectangle':
      return { width: 681, height: 468 }
    default:
      return { width: 681, height: 468 }
  }
}

export default getTableCardImageSize
